import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";
import { INSPECT_MAX_BYTES } from "buffer";

export default class Scenario4Part3 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 2;
	chapterIds = {
		scenario4_3A_s4b:'CALM - Scenario 4 - 3A - Segment 4B',
		scenario4_3A_s5: 'CALM - Scenario 4 - 3A - Segment 5',
		scenario4_3A_s6: 'CALM - Scenario 4 - 3A - Segment 6',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part3.id;
	}

	public start() {
		const context = this;
		context.segment1Step2DecideAction();
	}

	private segment1Step2DecideAction() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-L3-000a',
			[{
				text: 'Look up policies on the nurses’ station computer. ',
				feedback: 'You do not have time to look up a policy for a Medical Emergency Code. Your most important task is to ensure patient safety and support the Medical Emergency Code. When time permits, look up the policy to ensure all procedures were addressed.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Go to Medical Emergency Code room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}, {
				text: ' Determine re-staffing for Medical Emergency Code primary RN.',
				feedback: 'While it is important to re-staff the patients assigned to the Medical Emergency Code primary RN, your first priority is to ensure a response to the Medical Emergency Code occurs.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				this.scenario.stopAmbientLoop(this.scenario.audioHall);				
				context.scenario.evaluateAnswer(selectedOption, () =>
					context.segment2Step1HeatherGreets(), context.partIndx);
			}
		);
		context.scenario.updateObjective('How should you respond?');
	}

	private segment2Step1HeatherGreets() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		this.scenario.playAudio(this.scenario.audioHallToRoom,false);
		context.playVideoChapter(this.chapterIds.scenario4_3A_s4b, () =>
			context.segment2Step2FirstResponse())
	}

	private segment2Step2FirstResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-S1-020e', //CN-C01-L3-020a is Heather's line, but this comes after that line and is what prompts the action to be taken
			[{
				text: 'Re-staff RN Heather’s patients.',
				feedback: 'While it is important to re-staff the patients assigned to the Medical Emergency Code primary RN, your first priority is to ensure a response to the Medical Emergency Code occurs.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Identify a family representative to stay in the room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () =>
					context.segment3Step1JamieResponds(), 
					context.partIndx);

			}
		);
		context.scenario.updateObjective('How do you respond?');
		this.scenario.playAmbientLoop(this.scenario.audioRoom, true);
	}

	private segment3Step1JamieResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario4_3A_s5, () => {
			this.segment3Step2SelectResponse();
		});
		context.scenario.updateObjective('');
	}

	private segment3Step2SelectResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C01-L3-070a-1', 
			[{
				text: 'I’ll escort the family members out of the room myself. ',
				feedback: 'While you could escort the family members out, it will take time to provide comfort and explain what is happening to the patient. Remember, you need to re-staff the patients! This is a good time to delegate duties.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'I’ll tell LPN Jamie to escort the family members out of the room.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => {
					context.segment4Step1JamieEscort();
					context.scenario.stopAmbientLoop(this.scenario.audioRoom);
				},
				context.partIndx);

			}
		);
		context.scenario.updateObjective('How do you respond?');
	}

	private segment4Step1JamieEscort() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.playAudio(this.scenario.audioRoomToHall,false);
		context.playVideoChapter(context.chapterIds.scenario4_3A_s6, () => {
			this.scenario.playAmbientLoop(this.scenario.audioHall, true);
			this.onDone();
		});
		context.scenario.updateObjective('Re-staff Heather\'s patients');
	}

}